$(function () {
  if (window.navigator.userAgent.includes('PTST')) {
    return
  }

  if (!window.disableBeforeConsent) {
    document.body.className += ' not-gdpr'
  }

  const { config } = JSON.parse($('[data-consent-options]').html())

  console.log('config', config)

  function toggleShopifyCookies(categories) {
    // shopify analytics cookie
    const trackingConsent = {
      analytics: false,
      marketing: false,
      preferences: false,
    }
    if (categories.includes('analytics') || categories.includes('targeting')) {
      trackingConsent.analytics = true
    }
    if (categories.includes('advertising') || categories.includes('targeting')) {
      trackingConsent.marketing = true
    }
    if (categories.includes('performance')) {
      trackingConsent.preferences = true
    }

    if (!window.Shopify.loadFeatures) {
      // checkout 页面没有 customer privacy api，需要手动请求
      const url = 'https://' + window.location.host + '/set_tracking_consent.json'
      const body = JSON.stringify({
        granular_consent: trackingConsent,
        referrer: '',
        landing_page: '/',
      })

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      })
    } else {
      // 调用customer privacy api设置
      const setTrackingConsentCallback = (consentResult) => {
        if (consentResult?.data?.consentManagement?.cookies?.trackingConsentCookie) {
          window.document.cookie = `_tracking_consent=${consentResult.data.consentManagement.cookies.trackingConsentCookie};domain=.ankerwork.com;path=/;expires=365;category=necessary`
        }
      }

      if (window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent).then((consentResult) => {
          setTrackingConsentCallback(consentResult)

          if (!trackingConsent.analytics && !trackingConsent.marketing) {
            clearCookie(['necessary'])
          }
        })
      } else {
        window.Shopify.loadFeatures(
          [
            {
              name: 'consent-tracking-api',
              version: '0.1',
            },
          ],
          (loadError) => {
            if (loadError) {
              console.log('consent-tracking-api load error', loadError)
              return
            }

            window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent).then((consentResult) => {
              setTrackingConsentCallback(consentResult)

              if (!trackingConsent.analytics && !trackingConsent.marketing) {
                clearCookie(['necessary'])
              }
            })
          }
        )
      }
    }
  }

  function setCookieCategory(type) {
    if (!window.cookieTable || !window.cookieTable[type]) {
      return
    }

    Object.values(window.cookieTable[type]).forEach(({ name, value, options }) => {
      document.cookie = `${name}=${value};${options ? options.join(';') : ''}`
    })
  }

  function _deleteCookie(cookieName, domain) {
    document.cookie = `${cookieName}=;Path=/;Expires=Thu, 01 Jan 1970 00:00:00 UTC;${domain ? `Domain=${domain};` : ''}`
    document.cookie = `${cookieName}=;Path=/;Secure=true;Expires=Thu, 01 Jan 1970 00:00:00 UTC;${
      domain ? `Domain=${domain};` : ''
    }`
    document.cookie = `${cookieName}=;Path=/;SameSite=Lax;Expires=Thu, 01 Jan 1970 00:00:00 UTC;${
      domain ? `Domain=${domain};` : ''
    }`
    document.cookie = `${cookieName}=;Path=/;Secure=true;SameSite=Lax;Expires=Thu, 01 Jan 1970 00:00:00 UTC;${
      domain ? `Domain=${domain};` : ''
    }`
  }

  function deleteCookieInAllDomain(cookieName) {
    _deleteCookie(cookieName)
    _deleteCookie(cookieName, `${window.location.host}`)
    _deleteCookie(cookieName, `.${window.location.host}`)
    _deleteCookie(cookieName, `.${window.location.host.split('.').slice(1).join('.')}`)
  }

  function clearCookie(categories = []) {
    document.cookie.split(';').forEach(function (cookieStr) {
      const [cookieName] = cookieStr.split('=').map((item) => item.trim())

      if (categories.length === 1) {
        if (
          !window.isNecessaryCookies(cookieName) &&
          cookieName !== 'cc_cookie' &&
          cookieName !== '_tracking_consent'
        ) {
          deleteCookieInAllDomain(cookieName)
        }
      }
    })
  }

  function handleCookieConsentChange(categories) {
    if (categories.includes('advertising')) {
      window.dataLayer.push({
        event: 'cookie allow advertising',
      })
    } else {
      window.dataLayer.push({
        event: 'cookie disallow advertising',
      })
    }

    if (categories.includes('performance')) {
      window.dataLayer.push({
        event: 'cookie allow performance',
      })
    } else {
      window.dataLayer.push({
        event: 'cookie disallow performance',
      })
    }

    if (categories.includes('analytics')) {
      window.dataLayer.push({
        event: 'cookie allow analytics',
      })
    } else {
      window.dataLayer.push({
        event: 'cookie disallow analytics',
      })
    }

    if (categories.includes('targeting')) {
      window.dataLayer.push({
        event: 'cookie allow targeting',
      })
    } else {
      window.dataLayer.push({
        event: 'cookie disallow targeting',
      })
    }

    if (categories.includes('functional')) {
      window.dataLayer.push({
        event: 'cookie allow functional',
      })
    } else {
      window.dataLayer.push({
        event: 'cookie disallow functional',
      })
    }
  }

  function emitCookieConsentEvent(cookieCategories) {
    if (cookieCategories.includes('advertising')) {
      const allowEvent = new Event('cookie allow advertising')
      window.dispatchEvent(allowEvent)
    } else {
      const disallowEvent = new Event('cookie disallow advertising')
      window.dispatchEvent(disallowEvent)
    }

    if (cookieCategories.includes('performance')) {
      const allowEvent = new Event('cookie allow performance')
      window.dispatchEvent(allowEvent)
    } else {
      const disallowEvent = new Event('cookie disallow performance')
      window.dispatchEvent(disallowEvent)
    }

    if (cookieCategories.includes('targeting')) {
      const allowEvent = new Event('cookie allow targeting')
      window.dispatchEvent(allowEvent)
    } else {
      const disallowEvent = new Event('cookie disallow targeting')
      window.dispatchEvent(disallowEvent)
    }

    if (cookieCategories.includes('functional')) {
      const allowEvent = new Event('cookie allow functional')
      window.dispatchEvent(allowEvent)
    } else {
      const disallowEvent = new Event('cookie disallow functional')
      window.dispatchEvent(disallowEvent)
    }

    if (cookieCategories.includes('analytics')) {
      const allowEvent = new Event('cookie allow analytics')
      window.dispatchEvent(allowEvent)
    } else {
      const disallowEvent = new Event('cookie disallow analytics')
      window.dispatchEvent(disallowEvent)
    }
  }

  function handleAccept(cookieConsentConfig) {
    window.consentedCookie = true
    window.cookieCategories = cookieConsentConfig.categories

    if (cookieConsentConfig.categories.length === 1 && cookieConsentConfig.categories[0] === 'necessary') {
      window.disableCookies = true
    } else {
      window.disableCookies = false
    }

    clearCookie(cookieConsentConfig.categories)

    window.cookieCategories.forEach(setCookieCategory)

    toggleShopifyCookies(cookieConsentConfig.categories)
  }

  function modalCollect(position, label) {
    dataLayer.push({
      event: 'uaEvent',
      eventCategory: 'cookies_pop',
      eventAction: position,
      eventLabel: label, //按钮文案，右上角关闭传close
      nonInteraction: true,
    })
    window.dataLayer.push({ event_parameters: null })
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'lp_button',
      event_parameters: {
        page_group: 'cookies_pop',
        position: position,
        button_name: label, //按钮文案，右上角关闭传close
      },
    })
  }

  function consentModalCollect(buttonText) {
    modalCollect('pop_1', buttonText)
  }

  function settingsModalCollect(buttonText) {
    modalCollect('pop_2', buttonText)
  }

  let firstAction = false
  if (disableBeforeConsent) {
    toggleShopifyCookies(window.cookieCategories.length ? window.cookieCategories : ['necessary'])
  } else {
    toggleShopifyCookies(
      window.cookieCategories.length ? window.cookieCategories : ['necessary', 'functional', 'performance', 'targeting']
    )
  }

  window.CookieConsent.run({
    root: '#cookie-consent',
    autoClearCookies: true,
    manageScriptTags: true,
    autoShow: true,
    guiOptions: {
      consentModal: {
        layout: 'box',
        position: 'bottom right',
      },
      preferencesModal: {
        layout: 'box',
      },
    },
    cookie: {
      domain: '.ankerwork.com',
      secure: true,
    },
    mode: disableBeforeConsent ? 'opt-in' : 'opt-out', // default: 'opt-in'; value: 'opt-in' or 'opt-out'
    categories: disableBeforeConsent
      ? {
          necessary: {
            enabled: true,
            readOnly: true,
          },
          functional: {
            enabled: false,
          },
          performance: {
            enabled: false,
          },
          targeting: {
            enabled: false,
          },
        }
      : {
          necessary: {
            enabled: true,
            readOnly: true,
          },
          functional: {
            enabled: true,
          },
          performance: {
            enabled: true,
          },
          targeting: {
            enabled: true,
          },
        },
    revision: 1,
    onConsent: ({ cookie }) => {
      handleAccept(cookie)
      emitCookieConsentEvent(cookie.categories)
    },
    onChange: ({ cookie }) => {
      handleAccept(cookie)
      emitCookieConsentEvent(cookie.categories)
      if (firstAction) {
        firstAction = false
      } else {
        handleCookieConsentChange(cookieConsentConfig.categories)
      }
    },
    onFirstConsent: ({ cookie }) => {
      firstAction = true
      handleCookieConsentChange(cookie.categories)
    },
    ...config,
  })

  if (!window.document.cookie.includes('cc_cookie') && disableBeforeConsent) {
    handleAccept({ categories: ['necessary'] })
  }

  if (navigator.globalPrivacyControl) {
    CookieConsent.acceptCategory(['necessary'])
    handleAccept({ categories: ['necessary'] })
  }

  if (!window.consentedCookie) {
    modalCollect('pop_1', 'impression')
  }
})
